import CaseStudies from "../../componentLayer/pages/CaseStudies";
import Home from "../../componentLayer/pages/home/Infor/Home";
// import Home from "../../componentLayer/pages/home/Homepage";
export const homeRouter = [
  {
    index: true,
    element: <Home />,
  },
  {
    path: "casestudies",
    element: <CaseStudies />,
  },

  // {
  //   path:"contact",
  //   index: true,
  //   element: <Contact />,
  // },
];
